import { Component, OnInit, ViewEncapsulation, NgZone } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { UtilitesService } from '@systemic/services';

declare let mApp: any;
declare let mUtil: any;
declare let mLayout: any;
@Component({
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  template: `<nav-header></nav-header>
              <jaspero-alerts></jaspero-alerts>
              <jaspero-confirmations></jaspero-confirmations>
              <simple-notifications></simple-notifications>
              <router-outlet></router-outlet>
              <app-footer></app-footer>`,
  encapsulation: ViewEncapsulation.None
})
export class AppLayoutComponent implements OnInit {
  constructor(private lib: UtilitesService, private _router: Router, private zone: NgZone) { }
  ngOnInit() {
    this.lib.script
      .loadScripts(
        'body',
        [
          'assets/vendors/base/vendors.bundle.js',
          'assets/theme/base/scripts.bundle.js'
        ],
        true
      )
      .then(result => {
        this.lib.script.setLoading(false);
      });
    this.lib.script.setLoading(false);
    this._router.events.subscribe(route => {
      if (route instanceof NavigationStart) {
        this.lib.script.setLoading(true);
        this.zone.runOutsideAngular(() => {
          (<any>mLayout).closeMobileAsideMenuOffcanvas();
          (<any>mLayout).closeMobileHorMenuOffcanvas();
          (<any>mUtil).scrollTop();
          // hide visible popover
          (<any>$('[data-toggle="m-popover"]')).popover('hide');
        });
      }
      if (route instanceof NavigationEnd) {

        this.zone.runOutsideAngular(() => {
          (<any>mApp).init();
          (<any>mUtil).init();
          (<any>mApp).initTooltips();
          // alert(1);
        });
        this.lib.script.setLoading(false);
        // content m-wrapper animation
        // tslint:disable-next-line:prefer-const
        let animation = 'm-animate-fade-in-up';
        $('.m-wrapper')
          .one(
            'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
            function (e) {
              $('.m-wrapper').removeClass(animation);
            }
          )
          .removeClass(animation)
          .addClass(animation);
      }
    });
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/app-layout.component.ts